/** Read featureAccess / aiHiringOnly from a JWT payload (client-side, no verify). */
export function readFeatureClaimsFromToken(token) {
  if (!token) return null;
  try {
    const part = String(token).split(".")[1];
    if (!part) return null;
    const padded = part + "=".repeat((4 - (part.length % 4)) % 4);
    const json = atob(padded.replace(/-/g, "+").replace(/_/g, "/"));
    const payload = JSON.parse(json);
    const user = payload?.user || payload;
    return {
      featureAccess: Array.isArray(user?.featureAccess)
        ? user.featureAccess.filter(Boolean)
        : [],
      aiHiringOnly: Boolean(user?.aiHiringOnly),
    };
  } catch {
    return null;
  }
}

export function mergeFeatureClaimsIntoUser(user, claims) {
  if (!user || !claims) return user;
  return {
    ...user,
    featureAccess: claims.featureAccess,
    aiHiringOnly: claims.aiHiringOnly,
  };
}

/**
 * Keep localStorage `user` in sync with JWT feature claims so Agent247-only /
 * AI Hiring-only users are routed correctly after an admin changes access or
 * after a silent token refresh.
 */
export function syncStoredUserFeatureClaims(token, overrides = null) {
  const fromToken = readFeatureClaimsFromToken(token);
  const claims = {
    featureAccess:
      overrides?.featureAccess !== undefined
        ? overrides.featureAccess
        : fromToken?.featureAccess || [],
    aiHiringOnly:
      overrides?.aiHiringOnly !== undefined
        ? Boolean(overrides.aiHiringOnly)
        : Boolean(fromToken?.aiHiringOnly),
  };
  if (!token && !overrides) return null;

  try {
    const raw = localStorage.getItem("user");
    const user = raw ? JSON.parse(raw) : {};
    const merged = mergeFeatureClaimsIntoUser(user, claims);
    localStorage.setItem("user", JSON.stringify(merged));
    return merged;
  } catch {
    return null;
  }
}

export default syncStoredUserFeatureClaims;
